import React from "react";
import { Navigate, useLocation } from "react-router-dom";
import { useAdminAuth } from "./AdminAuthContext";

export default function AdminProtected({ children }) {
  const { admin } = useAdminAuth();
  const location = useLocation();
  if (admin === null) {
    return (
      <div className="min-h-[70vh] flex items-center justify-center">
        <div className="text-sm text-zinc-500">Loading...</div>
      </div>
    );
  }
  if (admin === false) {
    return <Navigate to="/admin/login" replace state={{ from: location.pathname }} />;
  }
  return children;
}
